import { Skeleton } from '@wellesley/ui'

const SkeletonItem = () => {
  return (
    <div className="flex items-center space-x-xs p-xs">
      <Skeleton className="h-10 w-10 rounded-full" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
  )
}

export const SearchLoading = () => {
  return (
    <div className="flex flex-col gap-1">
      {Array.from({ length: 7 }, (_, index) => (
        <SkeletonItem key={index} />
      ))}
    </div>
  )
}
